import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { CATEGORIES, SUB_CATEGORY } from '../../../Utilities/APIs'
import useFetch from '../../../Utilities/Hooks/useFetch'

import Image from '../../Partials/Elements/Image/Image'

import '../Categories/Categories.css'


function SubCategories() {
  const { categoryId } = useParams()
  const [subCategories, loading] = useFetch(SUB_CATEGORY + 'getSubcategoryFromCategory/' + categoryId, 'true')
  console.log(subCategories)

  const [singleCategory, setSingleCategory] = useState(null)

  const { consumer } = useSelector(state => state.auth)

  useEffect(() => {

    async function getAndSetSingleCategory() {
      const catRes = await fetch(CATEGORIES + categoryId)
      const catData = await catRes.json()
      setSingleCategory(catData)
    }

    getAndSetSingleCategory()

  }, [categoryId])

  return (
    <>
      <section className='subcategory_section page_padding ss_page'>
        <div className="container">
          <div className="ph_wrapper">
            {
              consumer
                ?
                consumer.language === 'english'
                  ?
                  <h2 className='page_heading'>What is the <span>{singleCategory?.engName}</span> Topic you are searching for?</h2>
                  :
                  <h2 className='page_heading'>আপনি কোন <span>{singleCategory?.name}</span> বিষয়ে তথ্য খোঁজ করতে চাচ্ছেন?</h2>
                :
                <h2 className='page_heading'>আপনি কোন <span>{singleCategory?.name}</span> বিষয়ে তথ্য খোঁজ করতে চাচ্ছেন?</h2>
            }
          </div>

          <div className="row categories">
            {subCategories?.map(data => (
              <div className="col" key={data._id}>
                <Link to={`/allOrganizations/${data._id}`}>
                  <div className="category">
                    <div className="category_content">
                      <div className="category_img">
                        <Image imgSrc={data.image} imgAlt={data.name} />
                      </div>
                      <div className="category_title">
                        <h3>
                          {
                            consumer
                              ?
                              consumer.language === 'english'
                                ?
                                data.engName
                                :
                                data.name
                              :
                              data.name
                          }
                        </h3>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}

            {loading ? '...loading' : ''}
          </div>
        </div>
      </section>
    </>
  )
}

export default SubCategories